import request from '@/utils/request'
import qs from 'qs'
const workPath = '/education'

export function queryStudentBoutiqueCourses(data) {
    return request({
        url: '/shibboleth/power/central/user/queryStudentBoutiqueCourses',
        method: 'post',
        data: qs.stringify(data)
    })
}
export function getSchool(data) {
    return request({
        url: '/power/organ/listChildOrgan ',
        method: 'post',
        data: qs.stringify(data)
    })
}
export function getSinfo(data) {
    return request({
        url: '/shibboleth/power/central/user/listBoutiqueCourses ',
        method: 'post',
        data: qs.stringify(data)
    })
}

export function centralLearn(data) {
    return request({
        url: workPath + '/boutiquecoures/centralLearn',
        method: 'post',
        data: qs.stringify(data)
    })
}


export function pageCaseStudent(data) {
    return request({
        url: '/shibboleth/power/central/user/pageCaseStudent',
        method: 'post',
        data: qs.stringify(data)
    })
}


export function getDetails(data) {
    return request({
        url: '/shibboleth/power/central/user/getDetails',
        method: 'post',
        data: qs.stringify(data)
    })
}

export function listByFlag(data) {
    return request({
        url: '/shibboleth/power/central/user/listByFlag',
        method: 'post',
        data: qs.stringify(data)
    })
}


export function getBoutiqueCourses(data) {
    return request({
        url: '/education/boutiquecoures/getBoutiqueCoursesDetail',
        method: 'post',
        data: qs.stringify(data)
    })
}


// 智慧思政管理系统_项目申报
export function projectapplicationstatistics(data) {
    return request({
        url: '/power/pwDict/projectapplicationstatistics',
        method: 'post',
        data: qs.stringify(data)
    })
}
// 雷达图
export function projectCateNum(data) {
    return request({
        url: '/project/tjTaskIssue/projectCateNum',
        method: 'post',
        data: qs.stringify(data)
    })
}
// 各高校入选率排名
export function pagePassRate(data) {
    return request({
        url: '/project/tjTaskIssue/pagePassRate',
        method: 'post',
        data: qs.stringify(data)
    })
}

// 智慧思政管理系统_评先评优
export function countStasticMap(data) {
    return request({
        url: '/judge/judgeTaskIssue/countStasticMap',
        method: 'post',
        data: qs.stringify(data)
    })
}

// 智慧思政管理系统_任务督办
export function taskStasticMap(data) {
    return request({
        url: '/duty/taskDeploy/taskStasticMap',
        method: 'post',
        data: qs.stringify(data)
    })
}


// 热词
export function listkeywords(data) {
    return request({
        url: '/power/pwDict/listkeywords',
        method: 'post',
        data: qs.stringify(data)
    })
}


/* 融媒体总体数据统计*/
export function mediaStatics(data) {
    return request({
        url: '/work/direction/mediaStatics',
        method: 'post',
        data: qs.stringify(data)
    })
}


// 科技大学 -思想工作动态

export function pageNotLogins(data) {
    return request({
        url: '/portal/prNews/pageNotLogin',
        method: 'post',
        data: qs.stringify(data)
    })
}


// 疫情
export function punches(data) {
    return request({
        url: '/power/pwDict/punches',
        method: 'post',
        data: qs.stringify(data)
    })
}

// 按钮跳转地址
export function forwardlinkBtn(data) {
    return request({
        url: '/portal/prNews/forwardlink',
        method: 'post',
        data: qs.stringify(data)
    })
}

// 安大疫情数据统计
export function managerStatics(data) {
    return request({
        url: '/power/epDdUser/managerStatics',
        method: 'post',
        data: qs.stringify(data)
    })
}

// 智慧资助接口
export function getlistThdInterface(data) {
    return request({
        url: '/portal/prNews/listThdInterface',
        method: 'post',
        data: qs.stringify(data)
    })
}
export function getSum(data) {
    return request({
        url: '/workers/subsi/getSum',
        method: 'post',
        data: qs.stringify(data)
    })
}

export function listFirstChart(data) {
    return request({
        url: '/workers/subsi/listFirstChart',
        method: 'post',
        data: qs.stringify(data)
    })
}

export function listSecondChart(data) {
    return request({
        url: '/workers/subsi/listSecondChart',
        method: 'post',
        data: qs.stringify(data)
    })
}

export function listThirdChart(data) {
    return request({
        url: '/workers/subsi/listThirdChart',
        method: 'post',
        data: qs.stringify(data)
    })
}

export function listFourthChart(data) {
    return request({
        url: '/workers/subsi/listFourthChart',
        method: 'post',
        data: qs.stringify(data)
    })
}

export function getUrl(data) {
    return request({
        url: '/workers/subsi/getUrl',
        method: 'post',
        data: qs.stringify(data)
    })
}

export function getGrantApply(data) {
    return request({
        url: '/workers/subsi/getGrantApply',
        method: 'post',
        data: qs.stringify(data)
    })
}

export function getFoodCost(data) {
    return request({
        url: '/workers/subsi/getFoodCost',
        method: 'post',
        data: qs.stringify(data)
    })
}

export function getSuportList(data) {
    return request({
        url: '/workers/subsi/getSuportList',
        method: 'post',
        data: qs.stringify(data)
    })
}


export function getNormalGrant(data) {
    return request({
        url: '/workers/subsi/getNormalGrant',
        method: 'post',
        data: qs.stringify(data)
    })
}


export function viewFile(data) {
    return request({
        url: '/document/manager/viewFile',
        method: 'post',
        data: qs.stringify(data)
    })
}


export function downFile(data) {
    return request({
        url: '/document/manager/downFile',
        method: 'post',
        data: qs.stringify(data)
    })
}

export function recordViews(data) {
    return request({
        url: '/education/boutiquecoures/recordViews',
        method: 'post',
        data: qs.stringify(data)
    })
}

export function getDifficultProportion(data) {
    return request({
        url: '/workers/subsi/getDifficultProportion',
        method: 'post',
        data: qs.stringify(data)
    })
}


// WEBPACK FOOTER //
// ./src/api/resource.js